<template>
    <el-dialog
            title="添加分类"
            :visible="true"
            width="25%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" :rules="rules" class="mt20">
            <el-form-item label="分类名称:" prop="name">
                <el-input v-model="form.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序:" prop="sort">
                <el-input v-model="form.sort" clearable></el-input>
                <p>0-1000（数字越大越靠前)</p>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
             <el-button type="primary" @click="save('form')">保 存</el-button>
             <el-button @click="handleClose">取 消</el-button>

  </span>
    </el-dialog>
</template>

<script>
    const validateAcquaintance = (rule, value, callback) => {
        if (!value) {
            callback(new Error('必须输入排序'))
        }
        value = Number(value)
        if (typeof value === 'number' && !isNaN(value)) {
            if (value < 0 || value > 1000) {
                callback(new Error('排序在 0 至 1000 之间'))
            } else {
                callback()
            }
        } else {
            callback(new Error('排序必须为数字'))
        }
    }
    export default {
        name: "add-cate-dialog",
        data() {
            return {
                form: {
                    sort: '0',
                    name: ''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入分类名称', trigger: 'blur'}
                    ],
                    sort: [
                        /*{
                            required: true,
                            message: '请输入排序',
                            trigger: 'blur'
                        }, {
                            type: 'number',
                            message: '排序必须为数字',
                            trigger: 'blur'
                        },*/
                        {
                            required: true,
                            message: '请输入排序',
                        },
                        {
                            validator: validateAcquaintance, // 自定义验证
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        props: {
            type: {
                type: Number,
                default: 0
            },
            pId: {
                type: Number,
                default: 0
            },
            editId: {
                type: Number,
                default: 0
            }
        },
        methods:

            {

                save(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            if(this.editId){
                                let url = '/categories/' + this.editId;
                                this.$put('logistics',  url, {
                                    lang: '',
                                    category:this.editId,
                                    _method:'PUT',
                                    name: this.form.name,
                                    sort: this.form.sort
                                }).then(res => {
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success'
                                    });
                                    this.$emit('refresh');
                                    this.$router.push({name: 'announcementCate'});
                                    this.$emit('handleClose');
                                }).catch(error => {
                                    this.$message({
                                        type: 'error',
                                        message: error.message
                                    });

                                });
                                return;
                            }
                            this.$post('logistics',  '/categories', {
                                lang: '',
                                type: 1,
                                level: this.type,
                                pid: this.pId,
                                name: this.form.name,
                                sort: this.form.sort
                            }).then(res => {
                                if (res.message == '操作成功') {
                                    this.$message({
                                        message: '新增成功',
                                        type: 'success'
                                    });
                                    this.$emit('refresh');
                                    this.$router.push({name: 'announcementCate'});
                                    this.$emit('handleClose');
                                }
                            }).catch(error => {
                                this.$message({
                                    type: 'error',
                                    message: error.message
                                });

                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                handleClose() {
                    this.$emit('handleClose');
                }
            },
        created() {
            if (this.editId) {
               let url = '/categories/' + this.editId;
               this.$get('logistics',  url, {
                   lang:'',
                   category:this.editId
               }).then(res => {
                   this.form.name = res.data.name;
                   this.form.sort = res.data.sort;
               }).catch(function (error){
                   console.log(error);
               });
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>